import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { GSDevTools } from 'gsap/GSDevTools'

gsap.registerPlugin(SplitText, GSDevTools) 

export const initPreloader = () => {
	const preloader = true
	
	if (preloader && window.initialLoad) {

		const header = {
			logo: document.querySelector('.header__home'),
			cta: document.querySelector('.header__cta-wrapper'),
			navigation: document.querySelector('.header__menu-wrapper')
		}

		const banner = {
			heading: document.querySelector('.banner__heading'),
			subheading: document.querySelector('.banner__subheading'),
			text: document.querySelector('.banner__text'),
		}

		const tl = gsap.timeline({
			delay: 1,
			defaults: {
				duration: 1,
				ease: 'power3.inOut'
			}
		})

		tl.fromTo([header.logo, header.cta, header.navigation, banner.heading, banner.subheading, banner.text], {	
			y: 74,
			opacity: 0
		}, {
			y: 0,
			opacity: 1,
			duration: 0.8,
			stagger: 0.15,
			ease: 'power2.out',
			willChange: 'transform, opacity',
		})

		// GSDevTools.create({ animation: tl, name: 'Preloader' })

	}
}

export default () => {}